import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Layout from "components/Layout";
import api, { setAuthToken } from "utils/api";
import { parseHandoffAuthToken } from "utils/authHandoff";
import { setLogin, setLogout } from "state";
import "styles/auth.css";

const TawanHandoffPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = parseHandoffAuthToken(location.search, location.hash);
    const next =
      new URLSearchParams(location.search).get("next") || "/buchen";

    if (!token) {
      navigate(`/einloggen?next=${encodeURIComponent(next)}`, { replace: true });
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        dispatch(setLogin({ token, user: null }));
        setAuthToken(token);
        const { data } = await api.get("/auth/me", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (cancelled) return;
        if (!data?.user) {
          throw new Error("missing user");
        }
        dispatch(setLogin({ token, user: data.user }));
        navigate(next, { replace: true });
      } catch (err) {
        if (!cancelled) {
          setAuthToken(null);
          dispatch(setLogout());
          const apiMsg = err?.response?.data?.message;
          const isNetwork =
            !err?.response &&
            (err?.code === "ERR_NETWORK" || err?.message === "Network Error");
          setError(
            apiMsg ||
              (isNetwork
                ? "Verbindung zum Server fehlgeschlagen (oft CORS oder falsche API-URL im Dr.-Hoffmann-Deploy). Bitte melde dich direkt auf dieser Seite an — dasselbe Passwort gilt hier ebenfalls."
                : "Anmeldung von Tawan Spa konnte nicht übernommen werden. Bitte melde dich direkt auf dieser Seite an — dasselbe Passwort gilt hier ebenfalls.")
          );
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [dispatch, location.search, location.hash, navigate]);

  return (
    <Layout>
      <section className="auth-page">
        <div className="auth-card">
          <div className="auth-kicker">Tawan Spa</div>
          <h1>
            Anmeldung wird <em>übernommen</em>
          </h1>
          {error ? (
            <>
              <div className="auth-alert is-error">{error}</div>
              <p className="auth-lead">
                Bitte melde dich direkt auf dieser Seite an — dein Tawan-Spa-Passwort
                gilt hier ebenfalls.
              </p>
            </>
          ) : (
            <p className="auth-lead">Einen Moment bitte…</p>
          )}
        </div>
      </section>
    </Layout>
  );
};

export default TawanHandoffPage;
